import { Modal, message, Input } from "antd";
import eventBus from "@utils/eventBus";
import { useState, useEffect, useContext, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import styles from './index.module.scss'
import { AppContext } from "@utils/AppContext";
import dayjs from "dayjs";
import API from '@api/api'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import PSAIModal from "@PSAIComponents/PSAIModal";
import Utils from '@utils/utils'

const CashbackItem = (props) => {
    const formartMobile = (mobile) => {
        return mobile?.replace(/(\d{3})\d+(\d{4})/g, '$1***$2')
    }
    return (
        <div className={styles.CashbackItem}>
            <div className={styles.mobileItem}>
                <span>{formartMobile(props.record.mobile)}</span>
            </div>
            <div className={styles.cashItem}>
                <span>￥</span>
                <span>{props.record.cash}</span>
                <span>元</span>    
            </div>
        </div>
    )
}

function Cashback () {
    const [records, setRecords] = useState([])

    useEffect(() => {
        API.inviteRecords().then(res => {
            if (res.code != 0) throw new Error(res.message)
            // setRecords([
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            //     {mobile: '1123342423', cash: '12.4'},
            // ])
            setRecords(res.data)
        }).catch(err => {
            message.warning(err.message)
        })
    }, [])

    return (
        <div className={styles.Cashback}>
            <div className={styles.Table}>
                <div className={styles.Head}>
                    <span>手机号</span>
                    <span>返现</span>
                </div>
                <div className={`${styles.Body} _beauty_scrollbar`}>
                {
                    records.map((item, index) => (
                        <CashbackItem key={index} record={item} />
                    ))
                }
                </div>
            </div>
        </div>
    )
}

const WithdrawalItem = (props) => {
    return (
        <div className={`${styles.WithdrawalItem} ${props.record.status == '提现失败' && styles.failed}`}>
            <span>{props.record.orderId}</span>
            <span>{props.record.withdrawalAmount}</span>
            <span>{props.record.status}</span>
            <span>{props.record.createdTime}</span>
        </div>
    )
}

function Withdrawal () {
    const [records, setRecords] = useState([])

    useEffect(() => {
        API.withdrawalRecords().then(res => {
            if (res.code != 0) throw new Error(res.message)
            // setRecords([{
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "待提现",
            //     "withdrawalAmount": "10.00"
            //     },
            //     {
            //     "createdTime": "2024-06-24 10:48:38",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "成功",
            //     "withdrawalAmount": "40.00"
            //     }, {
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "提现失败",
            //     "withdrawalAmount": "10.00"
            //     }, {
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "提现中",
            //     "withdrawalAmount": "10.00"
            // }, {
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "提现中",
            //     "withdrawalAmount": "10.00"
            // }, {
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "提现中",
            //     "withdrawalAmount": "10.00"
            // }, {
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "提现中",
            //     "withdrawalAmount": "10.00"
            // }, {
            //     "createdTime": "2024-06-24 10:47:19",
            //     "orderId": "2024062622001450301455975663",
            //     "status": "提现中",
            //     "withdrawalAmount": "10.00"
            // }])
            setRecords(res.data)
        }).catch(err => {
            message.warning(err.message)
        })
    }, [])

    return (
        <div className={styles.Withdrawal}>
            <div className={styles.Table}>
                <div className={styles.Head}>
                    <span>订单号</span>
                    <span>提现金额</span>
                    <span>提现状态</span>
                    <span>提现时间</span>
                </div>
                <div className={`${styles.Body} _beauty_scrollbar`}>
                {
                    records.map((item, index) => (
                        <WithdrawalItem key={index} record={item} />
                    ))
                }
                </div>
            </div>
        </div>
    )
}

function ActivityRules () {
    return (
        <div className={styles.ActivityRules}>
            <p>活动规则</p>
            <ul>
                <li>1. 该活动需绑定手机号</li>
                <li>2. 仅邀请新用户且需达成下述条件有提现资格</li>
                <ul>
                    <li className={styles.RuleTitle}>有效用户需同时满足以下三点</li>
                    <li>① 需要认证手机号/即微信登录用户需要绑定手机号</li>
                    <li>② 活动期间内，任意两天登录PSAI并使用PSAI上传自己的图片进行生成</li>
                    <li>③ 用户无任何违规不良记录</li>
                </ul>
                <li>3. 提现具有上限，最高100元，满50元时可提现</li>
                <li>4. 提现奖励到账时间为三个工作日内</li>
            </ul>
        </div>
    )
}

const WithdrawalForm = forwardRef((props, ref) => {
    const onSubmit = () => {
        if (!validateAccount(account)) return
        if (!validateName(name)) return
        return API.handleWithdrawal({
            alipayAccount: account,
            alipayName: name,
        }).then(res => {
            console.log('handleWithdrawal', res)
            if (res.code == 0) {
                PSAIModal.confirm({
                    type: 'success',
                    title: '提现申请已提交',
                    content: '提现奖励预计三个工作日内到账'
                })
            } else if (res.code == -5043) { // 您还未参加此活动，无法提现
                PSAIModal.confirm({
                    title: res.message,
                    okText: '去邀请',
                    onOk: props.inviteFunc
                })
            } else if (res.code == -5044) { // 您暂时未满足提现要求
                PSAIModal.confirm({
                    title: '还未达到提现门槛',
                    content: '快快加油，提现金额到达50元时就可以提现啦！',
                    okText: '去邀请',
                    onOk: props.inviteFunc
                })
            } else if (res.code == -5045) { // 提现金额无法超过待提现金额
                PSAIModal.confirm({
                    title: res.message,
                    okText: '去邀请',
                    onOk: props.inviteFunc
                })
            } else if (res.code == -5046) { // 当前活动已结束，感谢支持
                PSAIModal.confirm({
                    title: res.message,
                    okText: '去邀请',
                    onOk: props.inviteFunc
                })
            } else if (res.code == -5048) { // 提现金额不足
                PSAIModal.confirm({
                    title: res.message,
                    okText: '去邀请',
                    onOk: props.inviteFunc
                })
            }
            eventBus.emit('updateUserInfo')
            eventBus.emit('updatePower')
            eventBus.emit('updateActivityInfo')
        }).catch(err => {

        }).finally(() => {
            props.closeFunc()
        })
    }

    useImperativeHandle(ref, () => ({
        onSubmit
    }))

    const [account, setAccount] = useState(props.alipayAccount)
    const [accountError, setAccountError] = useState()
    const handleAccountBlur = (e) => {
        validateAccount(e.target.value)
    }
    const handleAccountChange = (e) => {
        setAccountError()
        setAccount(e.target.value)
    }
    const validateAccount = (account) => {
        if (!String(account).trim()) {
            setAccountError('支付宝账号不能为空')
            return false
        }
        if (!Utils.validateContact(account) && !Utils.validateContact2(account)) {
            setAccountError('请输入正确的支付宝账号')
            return false
        }
        setAccountError()
        return true
    }

    const [name, setName] = useState(props.alipayName)
    const [nameError, setNameError] = useState()
    const handleNameBlur = (e) => {
        validateName(e.target.value)
    }
    const handleNameChange = (e) => {
        setNameError()
        setName(e.target.value)
    }
    const validateName = (name) => {
        if (!String(name).trim()) {
            setNameError('姓名不能为空')
            return false
        }
        setNameError()
        return true
    }


    return (
        <div className={styles.WithdrawalForm}>
            <p className={styles.Tips}>提现金额：{props.balance}元</p>
            <div className={`${styles.loginFormItem} ${accountError && styles.loginFormItem_error}`}>
                <Input
                    value={account}
                    size="large"
                    placeholder="请输入支付宝账号"
                    onBlur={handleAccountBlur}
                    onChange={handleAccountChange}
                />
                {accountError && <p className={styles.errorMsg}><ExclamationCircleOutlined />{accountError}</p>}
            </div>
            <div className={`${styles.loginFormItem} ${nameError && styles.loginFormItem_error}`}>
                <Input
                    value={name}
                    size="large"
                    placeholder="请输入姓名"
                    onBlur={handleNameBlur}
                    onChange={handleNameChange}
                />
                {nameError && <p className={styles.errorMsg}><ExclamationCircleOutlined />{nameError}</p>}
            </div>
        </div>
    )
})

const CahsbackForm = (props) => {
    const {globalActivity, globalUser} = useContext(AppContext)
    // 活动状态 0-未开始 1-进行中 2-已结束
    const ACTIVITY_240711_STATUS = useMemo(() => {
        if (!globalActivity) return 0
        const activity = globalActivity.ACTIVITY_240711
        // const now = dayjs('2024-07-14')
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        const end = dayjs(activity.endAt)
        return now.isBefore(start) ? 0 : now.isAfter(end) ? 2 : 1 
    })
    const beginAt = useMemo(() => {
        return globalActivity ? globalActivity.ACTIVITY_240711.beginAt.format('YYYY MM.DD') : '-'
    }, [globalActivity])
    const endAt = useMemo(() => {
        return globalActivity ? globalActivity.ACTIVITY_240711.endAt.format('YYYY MM.DD') : '-'
    }, [globalActivity])

    const [activityInfo, setActivityInfo] = useState()
    const fetchActivityData = () => {
        API.activityInviteInfo().then(res => {
            if (res.code != 0) return
            setActivityInfo(res.data)
            console.log('activityInviteInfo', res)
        })
    }
    useEffect(() => {
        fetchActivityData()
    }, [])

    const [step, setStep] = useState(0) // 0-活动规则 1-返现详情 2-提现记录

    const handleAgreement = () => {
        window.open('/活动参与协议.htm')
    }

    const handleInvite = () => {
        if (ACTIVITY_240711_STATUS == 0) return message.info('活动未开始')
        else if (ACTIVITY_240711_STATUS == 2) return message.info('活动已结束')
        if (!globalUser) return eventBus.emit('login')
        if (!globalUser.mobile) {
            message.warning('请先绑定手机号')
            eventBus.emit('bindOrChangeMobile')
            return props.closeFunc()
        }
        if (localStorage.getItem(`${globalUser.mobile}_activity_rules_20240626`)) {
            handleCopyLink()
        } else {
            PSAIModal.confirm({
                title: '活动协议',
                content: <div>
                    <p>参与活动前，请仔细阅读活动规则的各个条款，特别是与完成活动任务、领取活动奖励以及与用户账号异常/违规等相关的条款。</p>
                    <p>用户参与本活动即视为已充分阅读、理解本活动规则，并自愿受活动规则的约束。</p>
                    <p style={{marginTop: 24}}>阅读完整<a style={{color: 'rgba(57, 62, 253, 1)'}} href='/活动参与协议.htm' target="_blank">《活动协议》</a></p>
                </div>,
                okText: '同意',
                cancelText: '取消',
                onOk() {
                    handleCopyLink()
                },
                onCancel() {},
            })
        }
    }
    const handleCopyLink = () => {
        if (!globalUser?.invitationCode) return message.warning('服务器繁忙，请稍后再试')
        // invite
        // 需要保留source_id等
        let params = `invite_code=${globalUser.invitationCode}`
        const sourceId = sessionStorage.getItem('sourceId')
        if (sourceId) params += `&source_id=${sourceId}`
        const text = `${window.location.origin}/?${params}`
        const textarea = document.createElement('textarea');
        textarea.value = text
        document.body.appendChild(textarea);

        textarea.select();
        document.execCommand('copy');

        document.body.removeChild(textarea);

        message.success('链接已复制，快去邀请吧')
        localStorage.setItem(`${globalUser.mobile}_activity_rules_20240626`, 1)
    }

    const withdrawalFormRef = useRef()
    const [withdrawalOpen, setWithdrawalOpen] = useState(false)
    const [loading, setLoaidng] = useState(false)
    const handleWithdrawal = () => {
        if ((activityInfo?.balance || 0) == 0) return
        setWithdrawalOpen(true)
    }
    const handleWithdrawalSubmit = async () => {
        setLoaidng(true)
        await withdrawalFormRef.current.onSubmit()
        fetchActivityData()
        setLoaidng(false)
    }

    return (
        <div className={styles.Container}>
            <p>邀请好友赚百元红包</p>
            <p>活动时间：{beginAt} - {endAt}</p>
            <div className={`${styles.btn} ${ACTIVITY_240711_STATUS != 1 && styles.disabled}`} onClick={handleInvite}>{ACTIVITY_240711_STATUS == 0 ? '活动未开始' : ACTIVITY_240711_STATUS==1?'去邀请' : '活动已结束'}</div>
            <div className={styles.Agreement} onClick={handleAgreement}>活动协议</div>
            <div className={styles.CashbackInfo}>
                <div className={styles.head}>
                    <div>
                        <p><span className={styles.amount}>{activityInfo?.validUser || 0}</span><span className={styles.unit}>人</span></p>
                        <span>有效用户数</span>
                        <div style={{opacity: 0}}></div>
                    </div>
                    <div>
                        <p><span className={styles.amount}>{activityInfo?.balance || 0}</span><span className={styles.unit}>元</span></p>
                        <span>可提现金额</span>
                        {ACTIVITY_240711_STATUS == 1 ? <div className={`${(activityInfo?.balance || 0) == 0 && styles.disabled}`} onClick={handleWithdrawal}>去提现</div> : <div style={{opacity: 0}}></div>}
                    </div>
                </div>
                <div className={styles.navigate}>
                {
                    step == 0 ? 
                    <div className={styles.menus}>
                        <span onClick={() => setStep(1)}>返现详情</span>
                        <span onClick={() => setStep(2)}>提现记录</span>
                    </div> : 
                    <div className={styles.goback}>
                        <span onClick={() => setStep(0)}>{step == 1 ? '返现详情' : '提现记录'}</span>
                    </div>
                }
                </div>
                <div className={styles.content}>
                {
                    step == 0 ? <ActivityRules /> :
                    step == 1 ? <Cashback /> :
                    step == 2 ? <Withdrawal /> : ""
                }
                </div>
            </div>
            <PSAIModal
                open={withdrawalOpen}
                title="填写提现账号"
                okText="确认提现"
                maxWidth={500}
                onOk={handleWithdrawalSubmit}
                onCancel={() => setWithdrawalOpen(false)}
            >
                <WithdrawalForm
                    ref={withdrawalFormRef}
                    balance={activityInfo?.balance || 0}
                    alipayAccount={activityInfo?.alipayAccount || ''}
                    alipayName={activityInfo?.alipayName || ''}
                    closeFunc={() => setWithdrawalOpen(false)}
                    inviteFunc={handleInvite}
                />
            </PSAIModal>
        </div>
    )
}

export default function CahsbackModal () {
    const [open, setOpen] = useState(false)
    const handleCashback = () => {
        setOpen(true)
    }
    useEffect(() => {
        eventBus.on('cashbackActivity', handleCashback);
        return () => {
            eventBus.off('cashbackActivity', handleCashback);
        }
    }, [])

    return (
        <Modal
            title={null}
            footer={null}
            centered
            destroyOnClose
            open={open}
            getContainer='#root'
            wrapClassName={styles.CahsbackModalWrap}
            className={styles.CahsbackModal}
            onCancel={() => setOpen(false)}
            // onOk={okClick}
        >
            <CahsbackForm closeFunc={() => setOpen(false)} />
        </Modal>
    )
}